import React, { useState } from "react"
import PropTypes from "prop-types"
import { Menu, Dropdown, Button } from "antd"

import "./Footer.less"
// import { Link } from "gatsby"
import { CloseIcon } from "../Icon"

export default function FooterWidget() {
  const [hovered, setHovered] = useState(false)
  const toggleHover = () => setHovered(!hovered)

  const menu = (
    <Menu className="footer-widget-menu-items">
      <Menu.Item>
        <a
          // target="_blank"
          // rel="noopener noreferrer"
          href="/beasiswa/pendaftaran-beasiswa/"
        >
          Saya ingin mendaftar Beasiswa 2021
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          // target="_blank"
          // rel="noopener noreferrer"
          href="/riset/pendaftaran-penjadwalan/"
        >
          Saya ingin mendaftar Riset 2021
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          // target="_blank"
          // rel="noopener noreferrer"
          href="/investasi/dana-abadi/"
        >
          Saya ingin berinvestasi di LPDP
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://bantuan.lpdp.kemenkeu.go.id/"
        >
          Saya ingin meminta bantuan
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <div
      className={hovered ? "footer-widget active" : "footer-widget "}
      onMouseEnter={toggleHover}
      //   onMouseLeave={toggleHover}
    >
      <CloseIcon
        className="footer-widget-close hide-desktop"
        onMouseEnter={() => setHovered(!hovered)}
      />
      <svg
        className="lamp"
        width="18"
        height="24"
        viewBox="0 0 18 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.9142 2.26933C13.0109 0.571599 10.4507 -0.235469 7.89743 0.059856C3.95741 0.51222 0.676789 3.68189 0.0978592 7.59692C-0.338097 10.5486 0.699447 13.512 2.87299 15.5246C3.01127 15.652 3.09096 15.8551 3.09096 16.0817V18.8818C3.09096 20.0015 3.86488 20.9368 4.90355 21.2006V21.5999C4.90355 22.9234 5.98016 24 7.30366 24H10.6054C11.9289 24 13.0055 22.9234 13.0055 21.5999V21.2004C14.0438 20.9362 14.8173 20.0012 14.8173 18.8818V16.0731C14.8173 15.8528 14.897 15.6528 15.0368 15.5231C16.8635 13.8324 17.9112 11.4385 17.9112 8.95558C17.9112 6.40546 16.8189 3.96785 14.9142 2.26933ZM11.4054 21.5999C11.4054 22.0413 11.0468 22.3999 10.6054 22.3999H7.30366C6.86223 22.3999 6.50362 22.0413 6.50362 21.5999V21.2819H11.4054V21.5999ZM13.95 14.3488C13.4844 14.7801 13.2172 15.4082 13.2172 16.0731V18.8818C13.2172 19.3232 12.8586 19.6818 12.4172 19.6818H9.75454V12.174C10.5271 11.7904 11.443 11.8531 12.157 12.3628C12.4008 12.537 12.7203 12.5589 12.9883 12.4237C13.2547 12.2862 13.4219 12.012 13.4219 11.7119V5.96325C13.4219 5.70465 13.2969 5.46244 13.0867 5.31244C11.8623 4.43633 10.2797 4.34687 8.96607 5.03733C7.72148 4.37734 6.21878 4.42333 5.00354 5.19525L4.85743 5.28822C4.62695 5.4351 4.48711 5.6898 4.48711 5.96325V11.712C4.48711 12.0041 4.64649 12.2729 4.90197 12.4135C5.15822 12.5534 5.46996 12.5432 5.71684 12.387L5.86294 12.294C6.56483 11.8463 7.42781 11.8086 8.15446 12.1652V19.6818H5.49106C5.04963 19.6818 4.69102 19.3232 4.69102 18.8818V16.0817C4.69102 15.4113 4.4246 14.7801 3.96051 14.3496C2.14715 12.6722 1.31664 10.2963 1.68072 7.83131C2.15574 4.62023 4.84727 2.02011 8.08023 1.649C8.37634 1.61541 8.67166 1.59821 8.96386 1.59821C10.7741 1.59821 12.4828 2.24511 13.8485 3.46314C15.4134 4.8593 16.3111 6.86095 16.3111 8.95557C16.3111 11.0236 15.4728 12.9394 13.95 14.3488ZM8.15447 10.4595C7.47866 10.2759 6.76613 10.2759 6.08719 10.4627V6.41874C6.7427 6.09373 7.50367 6.09373 8.15447 6.41406V10.4595ZM9.75454 10.4627V6.41874C10.41 6.09373 11.171 6.09373 11.8218 6.41406V10.4595C11.1468 10.2759 10.4343 10.2759 9.75454 10.4627Z"
          fill="black"
        />
      </svg>
      <span className="footer-widget-text first">Halo</span>
      <span className="footer-widget-main">
        <span className="footer-widget-text">Apa yang ingin Anda lakukan?</span>
        <Dropdown overlay={menu} placement="topLeft">
          <Button className="footer-widget-button">
            Saya Ingin...
            <svg
              width="9"
              height="10"
              viewBox="0 0 9 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.35156 4.77344C4.5625 4.98438 4.91406 4.98438 5.125 4.77344L8.3125 1.58594C8.54688 1.35156 8.54688 1 8.3125 0.789062L7.79688 0.25C7.5625 0.0390625 7.21094 0.0390625 7 0.25L4.72656 2.52344L2.47656 0.25C2.26562 0.0390625 1.91406 0.0390625 1.67969 0.25L1.16406 0.789062C0.929688 1 0.929688 1.35156 1.16406 1.58594L4.35156 4.77344Z"
                fill="#4F4B4A"
              ></path>
            </svg>
          </Button>
        </Dropdown>
      </span>
    </div>
  )
}

FooterWidget.prototypes = {
  footerMenu: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  }),
}
